// salesService.js
import axios from 'axios';

const CATERING_API = 'https://backend.maamaas.com/catering/api';
const ADMIN_ID = localStorage.getItem("userId" || 1); // You can get this from localStorage or props
const API_BASE_URL = 'https://backend.maamaas.com/catering/';
// Get auth token helper
const getAuthToken = () => {
    return localStorage.getItem("authToken");
};

// ==================== GET ALL DISHES ====================
export const getAllDishes = async () => {
    try {
        const token = getAuthToken();
        const response = await axios.get(
            `${CATERING_API}/user/dishes/getAll`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error('❌ Error fetching dishes:', error);
        throw error;
    }
};

// ==================== CREATE ENQUIRY ====================
// In the createEnquiry function, make sure latitude and longitude are included
export const createEnquiry = async (enquiryData) => {
    try {
        const token = getAuthToken();
        // Ensure latitude and longitude are numbers
        const payload = {
            ...enquiryData,
            latitude: parseFloat(enquiryData.latitude) || 0,
            longitude: parseFloat(enquiryData.longitude) || 0,
        };
        const response = await axios.post(
            `${CATERING_API}/user/enquiry/create/?adminId=${ADMIN_ID}`,
            payload,
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error('❌ Error creating enquiry:', error);
        throw error;
    }
};

// In salesService.js - add this helper
const convertDateFromAPI = (dateStr) => {
    if (!dateStr) return null;
    try {
        // Input is DD-MM-YYYY, convert to YYYY-MM-DD for display
        const parts = dateStr.split('-');
        return `${parts[2]}-${parts[1]}-${parts[0]}`;
    } catch {
        return dateStr;
    }
};

// Update getAllEnquiries function
export const getAllEnquiries = async () => {
    try {
        const token = getAuthToken();
        const response = await axios.get(
            `${CATERING_API}/admin/get/enquiry?adminId=${ADMIN_ID}`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            }
        );
        // Convert dates from API format (DD-MM-YYYY) to display format (YYYY-MM-DD)
        const data = response.data || [];
        return data.map(enquiry => ({
            ...enquiry,
            eventDate: enquiry.eventDate ? convertDateFromAPI(enquiry.eventDate) : '',
            fromDate: enquiry.fromDate ? convertDateFromAPI(enquiry.fromDate) : '',
            toDate: enquiry.toDate ? convertDateFromAPI(enquiry.toDate) : '',
        }));
    } catch (error) {
        console.error('❌ Error fetching enquiries:', error);
        throw error;
    }
};

// ==================== GET ENQUIRY BY ID ====================
export const getEnquiryById = async (enquiryId) => {
    try {
        const token = getAuthToken();
        const response = await axios.get(
            `${CATERING_API}/admin/get/enquiry/${enquiryId}?adminId=${ADMIN_ID}`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            }
        );
        const enquiry = response.data;
        // Convert dates from API format to display format
        return {
            ...enquiry,
            eventDate: enquiry.eventDate ? convertDateFromAPI(enquiry.eventDate) : '',
            fromDate: enquiry.fromDate ? convertDateFromAPI(enquiry.fromDate) : '',
            toDate: enquiry.toDate ? convertDateFromAPI(enquiry.toDate) : '',
        };
    } catch (error) {
        console.error('❌ Error fetching enquiry:', error);
        throw error;
    }
};

// ==================== UPDATE ENQUIRY ====================
// salesService.js - Update/Add these functions

// ==================== UPDATE ENQUIRY (Full Update) ====================

// Also update updateEnquiry if needed
export const updateEnquiry = async (enquiryId, enquiryData) => {
    try {
        const token = getAuthToken();
        const payload = {
            ...enquiryData,
            latitude: parseFloat(enquiryData.latitude) || 0,
            longitude: parseFloat(enquiryData.longitude) || 0,
        };
        const response = await axios.put(
            `${CATERING_API}/update/${enquiryId}`,
            payload,
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error('❌ Error updating enquiry:', error);
        throw error;
    }
};

// ==================== ADD ITEMS TO ENQUIRY ====================
export const addItemsToEnquiry = async (enquiryId, dishIds) => {
    try {
        const token = getAuthToken();
        const response = await axios.put(
            `${CATERING_API}/user/enquiry/additems/${enquiryId}`,
            { dishIds: dishIds },
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error('❌ Error adding items to enquiry:', error);
        throw error;
    }
};

// ==================== DELETE ENQUIRY ====================
export const deleteEnquiry = async (enquiryId) => {
    try {
        const token = getAuthToken();
        const response = await axios.delete(
            `${CATERING_API}/user/delete/${enquiryId}`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error('❌ Error deleting enquiry:', error);
        throw error;
    }
};

// ==================== ENUMS ====================
export const ENUMS = {
    source: ['APP', 'WEBSITE', 'ADMIN', 'TELE_CALL', 'WHATSAPP', 'WALK_IN', 'REFERRED', 'OTHER'],
    event: ['EVENT', 'DAILY'],
    eventType: ['WEDDING', 'BIRTHDAY', 'CORPORATE', 'ENGAGEMENT', 'ANNIVERSARY', 'OTHER', 'FESTIVAL', 'DAILY', 'WEEKLY', 'MONTHLY'],
    addOnType: ['SERVICE_BOYS', 'PAPER_PLATES', 'WATER_BOTTLES', 'DISPOSABLE_CUPS', 'TISSUE_PAPER'],
    leadStatus: ['PENDING', 'IN_PROGRESS', 'QUOTED', 'APPROVED', 'REJECTED', 'CLOSED']
};




// salesService.js - Add these new functions

// ==================== GET ALL VENDORS ====================
export const getAllVendors = async () => {
    try {
        const token = getAuthToken();
        const response = await axios.get(
            `${CATERING_API}/admin/get/all`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error('❌ Error fetching vendors:', error);
        throw error;
    }
};

// ==================== SEND ENQUIRY TO VENDORS ====================
export const sendEnquiryToVendors = async (enquiryId, payload) => {
    try {
        const token = getAuthToken();
        const response = await axios.put(
            `${CATERING_API}/admin/approval/${enquiryId}`,
            payload,
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error('❌ Error sending enquiry to vendors:', error);
        throw error;
    }
};



// ============================================
// LEAD MANAGEMENT APIs - Compatible with existing structure
// ============================================

// Get all leads
export const getAllLeads = async () => {
    try {
        const token = localStorage.getItem("authToken");
        const response = await axios.get(`${API_BASE_URL}/api/leads`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching leads:', error);
        throw error;
    }
};

// Create a new lead
export const createLead = async (leadData) => {
    try {
        const token = localStorage.getItem("authToken");
        const response = await axios.post(`${API_BASE_URL}/api/leads`, leadData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error creating lead:', error);
        throw error;
    }
};

// Update a lead
export const updateLead = async (leadId, leadData) => {
    try {
        const token = localStorage.getItem("authToken");
        const response = await axios.put(`${API_BASE_URL}/api/leads/${leadId}`, leadData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error updating lead:', error);
        throw error;
    }
};

// Delete a lead
export const deleteLead = async (leadId) => {
    try {
        const token = localStorage.getItem("authToken");
        const response = await axios.delete(`${API_BASE_URL}/api/leads/${leadId}`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        return response.data;
    } catch (error) {
        console.error('Error deleting lead:', error);
        throw error;
    }
};

// Convert lead to enquiry
export const convertLeadToEnquiry = async (leadId) => {
    try {
        const token = localStorage.getItem("authToken");
        const response = await axios.post(`${API_BASE_URL}/api/leads/${leadId}/convert`, {}, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error converting lead:', error);
        throw error;
    }
};

// Bulk upload leads
export const bulkUploadLeads = async (leadsData) => {
    try {
        const token = localStorage.getItem("authToken");
        const response = await axios.post(`${API_BASE_URL}/api/leads/bulk`, leadsData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error bulk uploading leads:', error);
        throw error;
    }
};

// Update lead payment status (for Razorpay integration)
export const updateLeadPayment = async (leadId, paymentData) => {
    try {
        const token = localStorage.getItem("authToken");
        const response = await axios.patch(`${API_BASE_URL}/api/leads/${leadId}/payment`, paymentData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error updating lead payment:', error);
        throw error;
    }
};

// ============================================
// QUOTATION MANAGEMENT APIs
// ============================================

// Accept a quotation - With detailed debugging
export const acceptQuotation = async (quotationId) => {
    try {
        const token = getAuthToken();

        //console.log("========== 🔍 DEBUGGING ACCEPT QUOTATION ==========");
        //console.log("1️⃣ Token from localStorage:", token);
        //console.log("2️⃣ Token type:", typeof token);
        //console.log("3️⃣ Token length:", token?.length);
        //console.log("4️⃣ Token first 20 chars:", token?.substring(0, 20) + "...");
        //console.log("5️⃣ Quotation ID:", quotationId);
        //console.log("6️⃣ Quotation ID type:", typeof quotationId);
        //console.log("7️⃣ API URL:", `${CATERING_API}/user/quotation/select/${quotationId}`);

        if (!token) {
            console.error("❌ No auth token found!");
            throw new Error("Authentication token not found. Please login again.");
        }

        // Check if token has the correct format
        if (!token.startsWith("ey")) {
            console.warn("⚠️ Token doesn't look like a JWT (doesn't start with 'ey')");
        }

        //console.log("8️⃣ Making POST request with:");
        //console.log("   - URL:", `${CATERING_API}/user/quotation/select/${quotationId}`);

        //console.log("   - Body: {}", "Empty object");

        const response = await axios.post(
            `${CATERING_API}/user/quotation/select/${quotationId}`,
            {},
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            }
        );

        //console.log("✅ SUCCESS! Response:", response.data);
        return response.data;
    } catch (error) {
        //console.log("========== ❌ ERROR DETAILS ==========");
        //console.log("Error object:", error);
        //console.log("Error message:", error.message);
        //console.log("Error code:", error.code);

        if (error.response) {
            //console.log("🔴 Response status:", error.response.status);
            //console.log("🔴 Response status text:", error.response.statusText);
            //console.log("🔴 Response headers:", error.response.headers);
            //console.log("🔴 Response data:", error.response.data);
            //console.log("🔴 Full response:", error.response);

            // Try to parse the error message
            if (error.response.data?.message) {
                //console.log("🔴 Error message from server:", error.response.data.message);
            }
            if (error.response.data?.error) {
                //console.log("🔴 Error from server:", error.response.data.error);
            }
        } else if (error.request) {
            //console.log("🔴 No response received. Request:", error.request);
        } else {
            //console.log("🔴 Error setting up request:", error.message);
        }

        //console.log("🔴 Config:", error.config);
        //console.log("=====================================");

        throw error;
    }
};


// In salesService.js

// Get all payments
export const getAllPayments = async () => {
    try {
        const token = localStorage.getItem("authToken");
        const response = await fetch("https://backend.maamaas.com/catering/api/admin/payments", {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            throw new Error(`Failed to fetch payments: ${response.status}`);
        }

        const data = await response.json();
        return data.data || [];
    } catch (error) {
        console.error('Error fetching payments:', error);
        throw error;
    }
};

// Get payments by lead ID
export const getPaymentsByLeadId = async (leadId) => {
    try {
        const allPayments = await getAllPayments();
        return allPayments.filter(payment => payment.leadId === leadId);
    } catch (error) {
        console.error('Error fetching payments by lead ID:', error);
        return [];
    }
};